import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const ErrorCircleSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="#568DFE"
			/>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="url(#paint0_linear_18367_49354)"
			/>
			<g clipPath="url(#clip0_18367_49354)">
				<path
					d="M16.268 8.81372C16.5667 8.51509 16.5667 8.03092 16.268 7.7323C15.9694 7.43367 15.4852 7.43367 15.1866 7.7323L12.0007 10.9183L8.81469 7.7323C8.51607 7.43367 8.0319 7.43367 7.73327 7.7323C7.43465 8.03092 7.43465 8.51509 7.73327 8.81372L10.9192 11.9997L7.73327 15.1856C7.43465 15.4843 7.43465 15.9684 7.73327 16.2671C8.0319 16.5657 8.51607 16.5657 8.8147 16.2671L12.0007 13.0811L15.1866 16.2671C15.4852 16.5657 15.9694 16.5657 16.268 16.2671C16.5667 15.9684 16.5667 15.4843 16.268 15.1856L13.0821 11.9997L16.268 8.81372Z"
					fill="white"
					stroke="white"
					strokeWidth="0.2"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_18367_49354"
					x1="22.35"
					y1="22.6364"
					x2="3"
					y2="13.3846"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
				<clipPath id="clip0_18367_49354">
					<rect width="16" height="16" fill="white" transform="translate(4 4)" />
				</clipPath>
			</defs>
		</IPortIconTemplate>
	)
})
